import { Button, styled } from '@mui/material';

export const ParamList = styled('div')({
  marginTop: '1em',
  padding: '10px',
  borderColor: 'rgb(194, 193, 193)',
  borderRadius: '10px',
  borderStyle: 'solid',
  marginBottom: '20px',

  span: {
    fontWeight: 'bold',
  },
});

export const ParamButton = styled('div')({
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '20px',
  height: '20px',
});

export const IconButton = styled(Button)({
  minWidth: '30px',
  padding: 0,
});

export const Flow = styled('div')({
  height: '50px',
  marginTop: '10px',
  backgroundColor: '#f5d1d1',
  padding: '10px',
  borderRadius: '10px',
});
